import React, { useMemo } from "react";
import { useGenericContext } from "@/context/generic";

const Section = ({ index, children }) => {
    const context = useGenericContext();
    const { state, simpleDispatch } = context;

    if (state?.step?.current !== index && state?.step?.previous !== index) return null;

    const animation = useMemo(() => {
        let animation = "";

        if (state.step.current === index) {
            if (state.step.direction >= 0) {
                animation = "scroll-right-in";
            } else {
                animation = "scroll-left-in";
            }
        } else {
            if (state.step.direction >= 0) {
                animation = "scroll-left-out";
            } else {
                animation = "scroll-right-out";
            }
        }

        return animation;
    }, [state.step.current, state.step.previous])

    return (
        <div className={ ["questions__section", animation].join(" ") }>
            {children}
        </div>
    );
};

export default Section;
